/**
 * Kapra.pk - Card Gallery Touch Swipe & Micro Pagination Dots Controller
 * Mobile: Touch horizontal swipe with thumb + micro pagination dots.
 * Desktop: Hover over card reveals second image (flat-lay); leaving returns to primary photo.
 * Safety: Tap navigates to product page; horizontal swipe changes image without accidental navigation.
 */
(function() {
  function initCardGalleries() {
    const galleries = document.querySelectorAll('.card-gallery:not([data-swipe-init])');
    galleries.forEach(gallery => {
      const count = parseInt(gallery.getAttribute('data-media-count') || '0', 10);
      if (count <= 1) return;

      gallery.setAttribute('data-swipe-init', 'true');
      const items = Array.from(gallery.querySelectorAll('.card-gallery__item'));
      const dots = Array.from(gallery.querySelectorAll('.card-gallery__dot'));
      if (items.length <= 1) return;

      let currentIndex = 0;
      let startX = 0;
      let startY = 0;
      let distX = 0;
      let distY = 0;
      let isHorizontalSwipe = false;
      let swipedJustNow = false;
      const threshold = 30; // min px to switch slide

      function goTo(index) {
        if (index < 0) index = items.length - 1;
        if (index >= items.length) index = 0;
        currentIndex = index;

        items.forEach((item, i) => {
          if (i === currentIndex) {
            item.classList.add('card-gallery__item--active');
          } else {
            item.classList.remove('card-gallery__item--active');
          }
        });

        dots.forEach((dot, i) => {
          if (i === currentIndex) {
            dot.classList.add('card-gallery__dot--active');
          } else {
            dot.classList.remove('card-gallery__dot--active');
          }
        });
      }

      // Intercept clicks when a swipe just occurred to prevent accidental product page opening
      gallery.addEventListener('click', (e) => {
        if (swipedJustNow) {
          e.preventDefault();
          e.stopPropagation();
          swipedJustNow = false;
        }
      }, true);

      // Pagination dot clicks
      dots.forEach((dot, idx) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          goTo(idx);
        });
        dot.addEventListener('touchend', (e) => {
          e.preventDefault();
          e.stopPropagation();
          goTo(idx);
        });
      });

      // Touch handling on mobile
      gallery.addEventListener('touchstart', (e) => {
        const touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        distX = 0;
        distY = 0;
        isHorizontalSwipe = false;
      }, { passive: true });

      gallery.addEventListener('touchmove', (e) => {
        if (!startX || !startY) return;
        const touch = e.touches[0];
        distX = touch.clientX - startX;
        distY = touch.clientY - startY;

        // Determine dominant axis
        if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > 10) {
          isHorizontalSwipe = true;
        }
      }, { passive: true });

      gallery.addEventListener('touchend', () => {
        if (isHorizontalSwipe && Math.abs(distX) >= threshold) {
          swipedJustNow = true;
          setTimeout(() => { swipedJustNow = false; }, 400);
          if (distX < 0) {
            // Swipe Left -> next photo
            goTo(currentIndex + 1);
          } else {
            // Swipe Right -> previous photo
            goTo(currentIndex - 1);
          }
        }
        startX = 0;
        startY = 0;
        distX = 0;
        distY = 0;
        isHorizontalSwipe = false;
      }, { passive: true });

      // Desktop Hover behavior (mouse devices only)
      gallery.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 750) {
          if (items.length > 1) {
            goTo(1); // Reveal second photo (fabric flat-lay)
          }
        }
      });

      gallery.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 750) {
          goTo(0); // Return to primary model photo
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardGalleries);
  } else {
    initCardGalleries();
  }

  document.addEventListener('shopify:section:load', initCardGalleries);
  const observer = new MutationObserver(() => {
    initCardGalleries();
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
